document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll(".bf-nav a");
    const activeIndicator = document.createElement("span");
    activeIndicator.className = "active-indicator";
    document.querySelector(".bf-nav").appendChild(activeIndicator);

    function setIndicatorPosition(activeLink) {
        const linkRect = activeLink.getBoundingClientRect();
        const navRect = document.querySelector(".bf-nav").getBoundingClientRect();
        const indicatorHeight = 100; // Full height of the nav

        // Adjust position for scrollable nav (especially on mobile)
        activeIndicator.style.position = "absolute";
        activeIndicator.style.bottom = "0";
        activeIndicator.style.left = `${linkRect.left - navRect.left + document.querySelector(".bf-nav").scrollLeft}px`;
        activeIndicator.style.width = `${linkRect.width}px`;
        activeIndicator.style.height = `${indicatorHeight}%`;
        activeIndicator.style.background = "white";
        activeIndicator.style.transition = "left 0.3s ease, width 0.3s ease";
    }

    navLinks.forEach((link) => {
        link.addEventListener("click", function (event) {
            event.preventDefault();

            // Remove active class from all links and set the clicked link as active
            navLinks.forEach((link) => link.classList.remove("active"));
            this.classList.add("active");

            setIndicatorPosition(this); // Update the indicator position
        });
    });

    const firstLink = navLinks[0];
    if (firstLink) {
        firstLink.classList.add("active"); 
        setIndicatorPosition(firstLink);
    }

    // Recalculate indicator position on nav scroll
    document.querySelector(".bf-nav").addEventListener("scroll", function () {
        const activeLink = document.querySelector(".bf-nav a.active");
        if (activeLink) {
            setIndicatorPosition(activeLink);
        }
    });

    // Recalculate indicator position on window resize
    window.addEventListener("resize", function () {
        const activeLink = document.querySelector(".bf-nav a.active");
        if (activeLink) {
            setIndicatorPosition(activeLink);
        }
    });
});
